'use client'

import { alpha } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'

// Types
import type { ComparisonColumnProps } from '@/types/components/molecules/solution'

// Components
import CheckIconAtom from '@/components/atoms/icon/two-tone/check'
import CrossIconAtom from '@/components/atoms/icon/two-tone/cross'
import MinusIconAtom from '@/components/atoms/icon/two-tone/minus'

// One option in the comparison: crosses for the traditional way, dashes for partial support, check marks for RateUp (highlighted)
const ComparisonColumnMolecule = (props: ComparisonColumnProps) => {
	// Props
	const { title, rows, mark } = props

	// Variables
	const highlighted = mark === 'check'

	return (
		<Box
			sx={{
				height: 1,
				p: { xs: 3, md: 4 },
				borderRadius: 5,
				...(highlighted
					? {
							bgcolor: 'common.white',
							border: t => `2px solid ${t.palette.primary.main}`,
							boxShadow: t => `0 30px 60px -30px ${alpha(t.palette.primary.dark, 0.5)}`
						}
					: { bgcolor: alpha('#fff', 0.5), border: '1px solid', borderColor: 'grey.200' })
			}}
		>
			<Typography sx={{ fontSize: 18, fontWeight: 700, color: highlighted ? 'primary.dark' : 'text.secondary' }}>{title}</Typography>

			<Box component="ul" sx={{ listStyle: 'none', m: 0, mt: 3, p: 0, display: 'flex', flexDirection: 'column', gap: 2.5 }}>
				{rows.map(row => (
					<Box component="li" key={row.label} sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
						<Box
							sx={{
								flexShrink: 0,
								width: 28,
								height: 28,
								borderRadius: '50%',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								bgcolor: highlighted ? 'primary.main' : mark === 'partial' ? 'grey.300' : 'grey.200',
								color: highlighted ? 'primary.contrastText' : mark === 'partial' ? 'grey.700' : 'grey.500',
								'& .MuiSvgIcon-root': { fontSize: 16 }
							}}
						>
							{highlighted ? <CheckIconAtom /> : mark === 'partial' ? <MinusIconAtom /> : <CrossIconAtom />}
						</Box>

						<Box>
							<Typography sx={{ fontSize: 12, fontWeight: 600, color: 'grey.700' }}>{row.label}</Typography>
							<Typography sx={{ fontSize: 15, fontWeight: highlighted ? 700 : 500, color: highlighted ? 'text.primary' : 'text.secondary' }}>{row.value}</Typography>
						</Box>
					</Box>
				))}
			</Box>
		</Box>
	)
}

export default ComparisonColumnMolecule
